import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Novedad.types';
import { INovedad } from './Novedad.lib';
import moment from 'moment';

export class Novedad extends INovedad
{

    public static async create( id: number ): Promise<Novedad>
    {
        let o = new Novedad();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    public static async Ultima(): Promise<Novedad>
    {
        let o = new Novedad();
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    protected Route: string = '/n468486b8d';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        if ( this.Id )
            request.path = `${this.Route}/${this.Id}`;
        else
            request.path = `${this.Route}`;
        if ( await request.get() )
        {

            this.Id = request.data.id;
            this.Fecha = moment( request.data.fecha );
            for ( let e of request.data.novedades )
            {
                this.Items.push( e );
            }

            this.Existe = this.Items.hasRows();
        }

        return this.Existe;
    }

    async MarcarVista(): Promise<boolean>
    {
        let request = new apiRequest();
        request.path = `/v468486b8d/${this.Id}`;
        if ( await request.post() )
        {
            return true;
        }
    }
}